import React, { useState, useEffect } from "react";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { hasuraClient } from "../../apolloClient";
import { VIEW_PROFILE } from "../../query/ViewProfile";
import { EDIT_BUSINESS_PROFILE } from "../../mutation/EditBusinessProfile";
import { EDIT_CLUB_PROFILE } from "../../mutation/EditClubProfile";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useHistory } from "react-router";
import styled from "styled-components";
import { ReactComponent as GreyClock } from "../../images/time-grey.svg";
import SearchAuto from "../LocationAutoComplete/SearchAuto";
import { VIEW_ROLE } from "../../query/ViewRole";
import DeleteEvent from "../Popup/DeleteEvent";
import { DELETE_USER } from "../../mutation/deleteUser";
import { onClickLogoutBtn } from "../Common/LogoutPopup";

const EditBusinessProfile = () => {
  const history = useHistory();
  const [MoOpen, setMonOpen] = useState("");
  const [MoClose, setMonClose] = useState("");
  const [TuOpen, setTuOpen] = useState("");
  const [TuClose, setTuClose] = useState("");
  const [WeOpen, setWeOpen] = useState("");
  const [WeClose, setWeClose] = useState("");
  const [ThOpen, setThOpen] = useState("");
  const [ThClose, setThClose] = useState("");
  const [FrOpen, setFrOpen] = useState("");
  const [FrClose, setFrClose] = useState("");
  const [SaOpen, setSaOpen] = useState("");
  const [SaClose, setSaClose] = useState("");
  const [SuOpen, setSuOpen] = useState("");
  const [SuClose, setSuClose] = useState("");

  const [workingMo, setWorkingMo] = useState(true);
  const [workingTu, setWorkingTu] = useState(true);
  const [workingWe, setWorkingWe] = useState(true);
  const [workingTh, setWorkingTh] = useState(true);
  const [workingFr, setWorkingFr] = useState(true);
  const [workingSa, setWorkingSa] = useState(true);
  const [workingSu, setWorkingSu] = useState(true);
  const [location_text, setLocation_text] = useState(null);
  const [cordinate, setCordinate] = useState(null);
  const [modalShowD, setModalShowD] = useState(false);

  const [errMsg, setErrMsg] = useState(false);
  const [opencloseTimeError, setopencloseTimeError] = useState(false);

  const [days, setDays] = React.useState([
    {
      dayName: "Monday",
      button_status: false,
      open: MoOpen,
      close: MoClose,
      openDate: null,
      closeDate: null,
    },
    {
      dayName: "Tuesday",
      button_status: false,
      open: TuOpen,
      close: TuClose,
      openDate: null,
      closeDate: null,
    },
    {
      dayName: "Wednesday",
      button_status: false,
      open: WeOpen,
      close: WeClose,
      openDate: null,
      closeDate: null,
    },
    {
      dayName: "Thursday",
      button_status: false,
      open: ThOpen,
      close: ThClose,
      openDate: null,
      closeDate: null,
    },
    {
      dayName: "Friday",
      button_status: false,
      open: FrOpen,
      close: FrClose,
      openDate: null,
      closeDate: null,
    },
    {
      dayName: "Saturday",
      button_status: false,
      open: SaOpen,
      close: SaClose,
      openDate: null,
      closeDate: null,
    },
    {
      dayName: "Sunday",
      button_status: false,
      open: SuOpen,
      close: SuClose,
      openDate: null,
      closeDate: null,
    },
  ]);

  useEffect(() => {
    setDays([
      {
        dayName: "Monday",
        button_status: false,
        open: workingMo && MoOpen ? moment(MoOpen).format("HH:mm") : null,
        close: workingMo && MoClose ? moment(MoClose).format("HH:mm") : null,
        openDate: null,
        closeDate: null,
      },
      {
        dayName: "Tuesday",
        button_status: false,
        open: workingTu && TuOpen ? moment(TuOpen).format("HH:mm") : null,
        close: workingTu && TuClose ? moment(TuClose).format("HH:mm") : null,
        openDate: null,
        closeDate: null,
      },
      {
        dayName: "Wednesday",
        button_status: false,
        open: workingWe && WeOpen ? moment(WeOpen).format("HH:mm") : null,
        close: workingWe && WeClose ? moment(WeClose).format("HH:mm") : null,
        openDate: null,
        closeDate: null,
      },
      {
        dayName: "Thursday",
        button_status: false,
        open: workingTh && ThOpen ? moment(ThOpen).format("HH:mm") : null,
        close: workingTh && ThClose ? moment(ThClose).format("HH:mm") : null,
        openDate: null,
        closeDate: null,
      },
      {
        dayName: "Friday",
        button_status: false,
        open: workingFr && FrOpen ? moment(FrOpen).format("HH:mm") : null,
        close: workingFr && FrClose ? moment(FrClose).format("HH:mm") : null,
        openDate: null,
        closeDate: null,
      },
      {
        dayName: "Saturday",
        button_status: false,
        open: workingSa && SaOpen ? moment(SaOpen).format("HH:mm") : null,
        close: workingSa && SaClose ? moment(SaClose).format("HH:mm") : null,
        openDate: null,
        closeDate: null,
      },
      {
        dayName: "Sunday",
        button_status: false,
        open: workingSu && SuOpen ? moment(SuOpen).format("HH:mm") : null,
        close: workingSu && SuClose ? moment(SuClose).format("HH:mm") : null,
        openDate: null,
        closeDate: null,
      },
    ]);
  }, [
    MoOpen,
    MoClose,
    TuOpen,
    TuClose,
    WeOpen,
    WeClose,
    ThOpen,
    ThClose,
    FrOpen,
    FrClose,
    SaOpen,
    SaClose,
    SuOpen,
    SuClose,
    workingMo,
    workingTu,
    workingWe,
    workingTh,
    workingFr,
    workingSa,
    workingSu,
  ]);

  const { data: userRole } = useQuery(VIEW_ROLE, {
    variables: {
      userId: localStorage.getItem("user_id"),
    },
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });

  const [BuildProfile] = useMutation(EDIT_BUSINESS_PROFILE, {
    client: hasuraClient,
  });
  const [DeleteUser] = useMutation(DELETE_USER, {
    client: hasuraClient,
  });
  const [BuildClubProfile] = useMutation(EDIT_CLUB_PROFILE, {
    client: hasuraClient,
  });

  const { data } = useQuery(VIEW_PROFILE, {
    client: hasuraClient,
  });

  useEffect(() => {
    if (userRole?.users[0].role === "business") {
      if (data?.users?.length > 0) {
        let arr = null;

        setLocation_text(data.users[0].business_profile.location_text);
        setCordinate(
          data?.users[0]?.business_profile?.location?.coordinates ?? [
            null,
            null,
          ]
        );

        if (typeof data.users[0].business_profile.opening_hours === "object") {
          arr = data.users[0].business_profile.opening_hours;
        } else {
          arr = JSON.parse(data.users[0].business_profile.opening_hours);
        }

        arr?.map((day) => {
          if (day.dayName === "Monday") {
            setMonOpen(
              day.open != null && day.open.length > 0
                ? moment(day.open, "HH:mm").toDate()
                : setWorkingMo(false)
            );
            setMonClose(
              day.close != null && day.close.length > 0
                ? moment(day.close, "HH:mm").toDate()
                : setWorkingMo(false)
            );
          }
          if (day.dayName === "Tuesday") {
            setTuOpen(
              day.open != null && day.open.length > 0
                ? moment(day.open, "HH:mm").toDate()
                : setWorkingTu(false)
            );
            setTuClose(
              day.close != null && day.close.length > 0
                ? moment(day.close, "HH:mm").toDate()
                : setWorkingTu(false)
            );
          }
          if (day.dayName === "Wednesday") {
            setWeOpen(
              day.open != null && day.open.length > 0
                ? moment(day.open, "HH:mm").toDate()
                : setWorkingWe(false)
            );
            setWeClose(
              day.close != null && day.close.length > 0
                ? moment(day.close, "HH:mm").toDate()
                : setWorkingWe(false)
            );
          }
          if (day.dayName === "Thursday") {
            setThOpen(
              day.open != null && day.open.length > 0
                ? moment(day.open, "HH:mm").toDate()
                : setWorkingTh(false)
            );
            setThClose(
              day.close != null && day.close.length > 0
                ? moment(day.close, "HH:mm").toDate()
                : setWorkingTh(false)
            );
          }
          if (day.dayName === "Friday") {
            setFrOpen(
              day.open != null && day.open.length > 0
                ? moment(day.open, "HH:mm").toDate()
                : setWorkingFr(false)
            );
            setFrClose(
              day.close != null && day.close.length > 0
                ? moment(day.close, "HH:mm").toDate()
                : setWorkingFr(false)
            );
          }
          if (day.dayName === "Saturday") {
            setSaOpen(
              day.open != null && day.open.length > 0
                ? moment(day.open, "HH:mm").toDate()
                : setWorkingSa(false)
            );
            setSaClose(
              day.close != null && day.close.length > 0
                ? moment(day.close, "HH:mm").toDate()
                : setWorkingSa(false)
            );
          }
          if (day.dayName === "Sunday") {
            setSuOpen(
              day.open != null && day.open.length > 0
                ? moment(day.open, "HH:mm").toDate()
                : setWorkingSu(false)
            );
            setSuClose(
              day.close != null && day.close.length > 0
                ? moment(day.close, "HH:mm").toDate()
                : setWorkingSu(false)
            );
          }
        });
      }
    } else {
      if (data?.users?.length > 0) {
        let arr = null;

        setLocation_text(data?.users[0]?.club_profile?.location_text);
        setCordinate(
          data?.users[0]?.club_profile?.location?.coordinates ?? [null, null]
        );

        if (typeof data?.users[0]?.club_profile?.opening_hours === "object") {
          arr = data.users[0].club_profile.opening_hours;
        } else {
          arr = JSON.parse(data.users[0].club_profile.opening_hours);
        }

        arr?.map((day) => {
          if (day.dayName === "Monday") {
            setMonOpen(
              day.open != null && day.open.length > 0
                ? moment(day.open, "HH:mm").toDate()
                : setWorkingMo(false)
            );
            setMonClose(
              day.close != null && day.close.length > 0
                ? moment(day.close, "HH:mm").toDate()
                : setWorkingMo(false)
            );
          }
          if (day.dayName === "Tuesday") {
            setTuOpen(
              day.open != null && day.open.length > 0
                ? moment(day.open, "HH:mm").toDate()
                : setWorkingTu(false)
            );
            setTuClose(
              day.close != null && day.close.length > 0
                ? moment(day.close, "HH:mm").toDate()
                : setWorkingTu(false)
            );
          }
          if (day.dayName === "Wednesday") {
            setWeOpen(
              day.open != null && day.open.length > 0
                ? moment(day.open, "HH:mm").toDate()
                : setWorkingWe(false)
            );
            setWeClose(
              day.close != null && day.close.length > 0
                ? moment(day.close, "HH:mm").toDate()
                : setWorkingWe(false)
            );
          }
          if (day.dayName === "Thursday") {
            setThOpen(
              day.open != null && day.open.length > 0
                ? moment(day.open, "HH:mm").toDate()
                : setWorkingTh(false)
            );
            setThClose(
              day.close != null && day.close.length > 0
                ? moment(day.close, "HH:mm").toDate()
                : setWorkingTh(false)
            );
          }
          if (day.dayName === "Friday") {
            setFrOpen(
              day.open != null && day.open.length > 0
                ? moment(day.open, "HH:mm").toDate()
                : setWorkingFr(false)
            );
            setFrClose(
              day.close != null && day.close.length > 0
                ? moment(day.close, "HH:mm").toDate()
                : setWorkingFr(false)
            );
          }
          if (day.dayName === "Saturday") {
            setSaOpen(
              day.open != null && day.open.length > 0
                ? moment(day.open, "HH:mm").toDate()
                : setWorkingSa(false)
            );
            setSaClose(
              day.close != null && day.close.length > 0
                ? moment(day.close, "HH:mm").toDate()
                : setWorkingSa(false)
            );
          }
          if (day.dayName === "Sunday") {
            setSuOpen(
              day.open != null && day.open.length > 0
                ? moment(day.open, "HH:mm").toDate()
                : setWorkingSu(false)
            );
            setSuClose(
              day.close != null && day.close.length > 0
                ? moment(day.close, "HH:mm").toDate()
                : setWorkingSu(false)
            );
          }
        });
      }
    }
  }, [data]);

  const setWorkingDay = (day) => {
    if (day === "Mo") {
      setWorkingMo(!workingMo);
    }
    if (day === "Tu") {
      setWorkingTu(!workingTu);
    }
    if (day === "We") {
      setWorkingWe(!workingWe);
    }
    if (day === "Th") {
      setWorkingTh(!workingTh);
    }
    if (day === "Fr") {
      setWorkingFr(!workingFr);
    }
    if (day === "Sa") {
      setWorkingSa(!workingSa);
    }
    if (day === "Su") {
      setWorkingSu(!workingSu);
    }
  };
  const MainDiv = styled.div`
    width: 186px;
    height: 40px;
    border: 1px solid #e8e9eb;
    display: flex;
    align-items: center;
    text-align: center;
    margin-left: 15px;
  `;
  const deleteUserHandler = () => {
    const user_id = `${
      data?.users?.length > 0 && data.users[0] && data.users[0].id
        ? data.users[0].id
        : ""
    }`;
    if (user_id) {
      DeleteUser({
        variables: {
          id: user_id,
        },
      })
        .then((res) => {
          if (res?.data?.delete_users?.affected_rows > 0) onClickLogoutBtn();
          else setModalShowD(false);
        })
        .catch((e) => {
          setModalShowD(false);
          console.error("error in deleting the account", e);
        });
    }
  };

  const deleteAccountHandler = () => {
    if (data?.users?.length > 0 && data?.users[0]) {
      setModalShowD(true);
    }
  };

  return (
    <>
      <DeleteEvent
        deleteEventHandler={deleteUserHandler}
        show={modalShowD}
        onHide={() => setModalShowD(false)}
        deleteObjectName="account"
      />
      {userRole?.users[0].role === "business" ? (
        <div className="edit-profile">
          <div className="edit-profile-box">
            <div className="title">
              <h2>Edit Business Profile</h2>
            </div>
            <Formik
              enableReinitialize={true}
              initialValues={{
                name: `${
                  data?.users?.length > 0 &&
                  data.users[0] &&
                  data.users[0].business_profile.name
                    ? data.users[0].business_profile.name
                    : ""
                }`,
                email: `${
                  data?.users?.length > 0 &&
                  data.users[0] &&
                  data.users[0].email
                    ? data.users[0].email
                    : ""
                }`,
                phone: `${
                  data?.users?.length > 0 &&
                  data.users[0] &&
                  data.users[0].business_profile.mobile_number
                    ? data.users[0].business_profile.mobile_number
                    : ""
                }`,
                website: `${
                  data?.users?.length > 0 &&
                  data.users[0] &&
                  data.users[0].business_profile.website
                    ? data.users[0].business_profile.website
                    : ""
                }`,
                description: `${
                  data?.users?.length > 0 &&
                  data.users[0] &&
                  data.users[0].business_profile.description
                    ? data.users[0].business_profile.description
                    : ""
                }`,
                openingHours: [
                  {
                    dayName: "Monday",
                    button_status: false,
                    open: "",
                    close: "",
                    openDate: null,
                    closeDate: null,
                  },
                  {
                    dayName: "Tuesday",
                    button_status: false,
                    open: "",
                    close: "",
                    openDate: null,
                    closeDate: null,
                  },
                  {
                    dayName: "Wednesday",
                    button_status: false,
                    open: "",
                    close: "",
                    openDate: null,
                    closeDate: null,
                  },
                  {
                    dayName: "Thursday",
                    button_status: false,
                    open: "",
                    close: "",
                    openDate: null,
                    closeDate: null,
                  },
                  {
                    dayName: "Friday",
                    button_status: false,
                    open: "",
                    close: "",
                    openDate: null,
                    closeDate: null,
                  },
                  {
                    dayName: "Saturday",
                    button_status: false,
                    open: "",
                    close: "",
                    openDate: null,
                    closeDate: null,
                  },
                  {
                    dayName: "Sunday",
                    button_status: false,
                    open: "",
                    close: "",
                    openDate: null,
                    closeDate: null,
                  },
                ],
              }}
              validationSchema={Yup.object({
                name: Yup.string().required("Please anter the name"),
                email: Yup.string().email("Invalid Email Address"),
                website: Yup.string().matches(
                  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
                  "Please Enter Valid URL"
                ),
                openingHours: Yup.array().of(
                  Yup.object({
                    open: Yup.string().when("button_status", {
                      is: (value) => value === true,
                      then: Yup.string().required(),
                      otherwise: Yup.string().nullable(),
                    }),
                    close: Yup.string().when("button_status", {
                      is: (value) => value === true,
                      then: Yup.string().required(),
                      otherwise: Yup.string().nullable(),
                    }),
                    // .test(
                    //   "is-greater",
                    //   "end time should be greater",
                    //   function (value) {
                    //     const { open } = this.parent;
                    //     return !open || !value
                    //       ? true
                    //       : moment(value, "h:mm aa").isSameOrAfter(
                    //           moment(open, "h:mm aa")
                    //         );
                    //   }
                    // ),
                  })
                ),
                phone: Yup.number()
                  .typeError("Please add only numbers")
                  .required("Please the enter the phone number"),
                description: Yup.string().required(
                  "Please enter the description"
                ),
              })}
              onSubmit={(values) => {
                // let flag = true;

                // for (let i = 0; i < days.length; i++) {
                //   // if (
                //   //   days[i].open != null &&
                //   //   days[i].close != null &&
                //   //   // days[i].open >= days[i].close
                //   // ) {
                //     flag = false;
                //     // break;
                //   }
                // }

                // if (true) {
                // setopencloseTimeError(false);
                if (values.description) {
                  if (/^\s*$/.test(values.description)) {
                    //only spaces in the value
                    setErrMsg(true);
                  } else {
                    setErrMsg(false);
                    BuildProfile({
                      variables: {
                        data: {
                          email: values.email,
                          mobile_number: values.phone,
                          website: values.website,
                          description: values.description,
                          location_text: location_text,
                          location: {
                            type: "Point",
                            coordinates: cordinate,
                          },
                          name: values.name,
                          opening_hours: JSON.stringify(days),
                        },
                        userId: `${
                          data?.users?.length > 0 &&
                          data.users[0] &&
                          data.users[0].id
                            ? data.users[0].id
                            : ""
                        }`,
                      },
                    })
                      .then(() => {
                        history.push("/business-profile");
                      })
                      .catch((e) => {});
                  }
                }

                //   } else {
                //     // setopencloseTimeError(true);
                //   }
                // }
              }}
            >
              {() => (
                <Form>
                  <div style={{ width: "49%" }}>
                    <div className="form-group full-width">
                      <label>Name</label>
                      <Field
                        type="name"
                        name="name"
                        className="form-control"
                        style={{ backgroundColor: "white" }}
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="error-message"
                      />
                    </div>
                    <div className="form-group full-width">
                      <label>Phone</label>
                      <Field type="tel" name="phone" className="form-control" />
                      <ErrorMessage
                        name="phone"
                        component="div"
                        className="error-message"
                      />
                    </div>
                    <div className="form-group full-width">
                      <label>Website</label>
                      <Field
                        type="text"
                        name="website"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="website"
                        component="div"
                        className="error-message"
                      />
                    </div>
                    <div className="form-group map-input full-width">
                      <label>Location</label>
                      {/* <Field type="text" name="address" className="form-control" />
                <ErrorMessage
                  name="address"
                  component="div"
                  className="error-message"
                /> */}
                      <SearchAuto
                        setCordinate={setCordinate}
                        setLocation_text={setLocation_text}
                        location_text={location_text}
                      />
                    </div>
                    {/* <div className="form-group">
                <label>Opening Hours</label>
                <Field type="text" name="xyz" className="form-control" />
                <ErrorMessage name="xyz" component="div" className="error-message" />
              </div> */}
                    {/* <div className="form-group">
                <label>Opening Hours</label>
                {days.map((day,i)=>{
                  return (
                    <div className="d-flex opening-hours-main-div">
                  <div>
                  <ul style={{listStyle:"none"}}>
                        <li>
                          <div class="">
                            <input type="checkbox" id="checkbox" 
                              onClick={()=>{
                              selectDayHandler(day.dayName)
                              setFieldValue(
                                `openingHours.${i}.button_status`,
                                !values.openingHours[i].button_status
                              )
                              }
                              }/>
                            <label for="checkbox">{day.dayName}</label>
                          </div>
                        </li>
                    </ul>
                  </div>
                  {
                    day.button_status ? 
                    <div className="d-flex" >
                      <div>
                      <div>
                        <DatePicker
                          selected={
                            values.openingHours[i].openDate
                          }
                          dropdownMode="select"
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={60}
                          dateFormat="h:mm aa"
                          autoComplete="off"
                          id={`openingHours.${i}.open`}
                          name={`openingHours.${i}.open`}
                          onChange={(value) => {
                            setFieldValue(
                              `openingHours.${i}.open`,
                              moment(value).format("HH:mm")
                            )
                            setFieldValue(
                              `openingHours.${i}.openDate`,
                              value
                            );
                          }}
                          className="react-time-input"
                          calendarClassName="react-time-picker"
                          popperClassName="react-time-propper"
                        />
                      </div>
                      </div>
                      <div>To</div>
                      <div>
                      <div>
                        <DatePicker
                          selected={
                            values.openingHours[i].closeDate
                          }
                          dropdownMode="select"
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={60}
                          dateFormat="h:mm aa"
                          autoComplete="off"
                          id={`openingHours.${i}.close`}
                          name={`openingHours.${i}.close`}
                          onChange={(value) => {
                            setFieldValue(
                              `openingHours.${i}.close`,
                              moment(value).format("HH:mm")
                            )
                            setFieldValue(
                              `openingHours.${i}.closeDate`,
                              value
                            );
                          }}
                          className="react-time-input"
                          calendarClassName="react-time-picker"
                          popperClassName="react-time-propper"
                        />
                      </div>
                      </div>
                  </div>
                  : null
                  }
                </div>
                  )
                })}
              </div> */}

                    <div className="time-block full-width">
                      <div className="main-title">
                        <h3>Set Opening Hours</h3>
                      </div>
                      <div className="opening-hours-cover">
                        <div className="col-left">
                          <div className="opening-hours-row">
                            <label
                              className="checkbox-row"
                              onClick={() => {
                                setWorkingDay("Mo");
                              }}
                            >
                              <div
                                className={
                                  workingMo ? "workingDay" : "nonWorkingDay"
                                }
                              >
                                Mo
                              </div>
                            </label>
                            {workingMo ? (
                              <div className="timer-row">
                                <div className="timer-one">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={MoOpen}
                                    onChange={(value) => {
                                      setMonOpen(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                                <div className="to-text">
                                  <p>—</p>
                                </div>
                                <div className="timer-two">
                                  <DatePicker
                                    selected={MoClose}
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    onChange={(value) => {
                                      setMonClose(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                              </div>
                            ) : (
                              <MainDiv>
                                <GreyClock
                                  style={{ marginLeft: 20, marginRight: 16 }}
                                />
                                <p
                                  style={{ marginBottom: 0, color: "#161F3D" }}
                                >
                                  Closed
                                </p>
                              </MainDiv>
                            )}
                          </div>
                          <div className="opening-hours-row">
                            <label
                              className="checkbox-row"
                              onClick={() => {
                                setWorkingDay("Tu");
                              }}
                            >
                              <div
                                className={
                                  workingTu ? "workingDay" : "nonWorkingDay"
                                }
                              >
                                Tu
                              </div>
                            </label>
                            {workingTu ? (
                              <div className="timer-row">
                                <div className="timer-one">
                                  <DatePicker
                                    selected={TuOpen}
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    onChange={(value) => {
                                      setTuOpen(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                                <div className="to-text">
                                  <p>—</p>
                                </div>
                                <div className="timer-two">
                                  <DatePicker
                                    selected={TuClose}
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    onChange={(value) => {
                                      setTuClose(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                              </div>
                            ) : (
                              <MainDiv>
                                <GreyClock
                                  style={{ marginLeft: 20, marginRight: 16 }}
                                />
                                <p
                                  style={{ marginBottom: 0, color: "#161F3D" }}
                                >
                                  Closed
                                </p>
                              </MainDiv>
                            )}
                          </div>
                          <div className="opening-hours-row">
                            <label
                              className="checkbox-row"
                              onClick={() => {
                                setWorkingDay("We");
                              }}
                            >
                              <div
                                className={
                                  workingWe ? "workingDay" : "nonWorkingDay"
                                }
                              >
                                We
                              </div>
                            </label>
                            {workingWe ? (
                              <div className="timer-row">
                                <div className="timer-one">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={WeOpen}
                                    onChange={(value) => {
                                      setWeOpen(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                                <div className="to-text">
                                  <p>—</p>
                                </div>
                                <div className="timer-two">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={WeClose}
                                    onChange={(value) => {
                                      setWeClose(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                              </div>
                            ) : (
                              <MainDiv>
                                <GreyClock
                                  style={{ marginLeft: 20, marginRight: 16 }}
                                />
                                <p
                                  style={{ marginBottom: 0, color: "#161F3D" }}
                                >
                                  Closed
                                </p>
                              </MainDiv>
                            )}
                          </div>
                          <div className="opening-hours-row">
                            <label
                              className="checkbox-row"
                              onClick={() => {
                                setWorkingDay("Th");
                              }}
                            >
                              <div
                                className={
                                  workingTh ? "workingDay" : "nonWorkingDay"
                                }
                              >
                                Th
                              </div>
                            </label>
                            {workingTh ? (
                              <div className="timer-row">
                                <div className="timer-one">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={ThOpen}
                                    onChange={(value) => {
                                      setThOpen(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                                <div className="to-text">
                                  <p>—</p>
                                </div>
                                <div className="timer-two">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={ThClose}
                                    onChange={(value) => {
                                      setThClose(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                              </div>
                            ) : (
                              <MainDiv>
                                <GreyClock
                                  style={{ marginLeft: 20, marginRight: 16 }}
                                />
                                <p
                                  style={{ marginBottom: 0, color: "#161F3D" }}
                                >
                                  Closed
                                </p>
                              </MainDiv>
                            )}
                          </div>
                          <div className="opening-hours-row">
                            <label
                              className="checkbox-row"
                              onClick={() => {
                                setWorkingDay("Fr");
                              }}
                            >
                              <div
                                className={
                                  workingFr ? "workingDay" : "nonWorkingDay"
                                }
                              >
                                Fr
                              </div>
                            </label>
                            {workingFr ? (
                              <div className="timer-row">
                                <div className="timer-one">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={FrOpen}
                                    onChange={(value) => {
                                      setFrOpen(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                                <div className="to-text">
                                  <p>—</p>
                                </div>
                                <div className="timer-two">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={FrClose}
                                    onChange={(value) => {
                                      setFrClose(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                              </div>
                            ) : (
                              <MainDiv>
                                <GreyClock
                                  style={{ marginLeft: 20, marginRight: 16 }}
                                />
                                <p
                                  style={{ marginBottom: 0, color: "#161F3D" }}
                                >
                                  Closed
                                </p>
                              </MainDiv>
                            )}
                          </div>
                          <div className="opening-hours-row">
                            <label
                              className="checkbox-row"
                              onClick={() => {
                                setWorkingDay("Sa");
                              }}
                            >
                              <div
                                className={
                                  workingSa ? "workingDay" : "nonWorkingDay"
                                }
                              >
                                Sa
                              </div>
                            </label>
                            {workingSa ? (
                              <div className="timer-row">
                                <div className="timer-one">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={SaOpen}
                                    onChange={(value) => {
                                      setSaOpen(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                                <div className="to-text">
                                  <p>—</p>
                                </div>
                                <div className="timer-two">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={SaClose}
                                    onChange={(value) => {
                                      setSaClose(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                              </div>
                            ) : (
                              <MainDiv>
                                <GreyClock
                                  style={{ marginLeft: 20, marginRight: 16 }}
                                />
                                <p
                                  style={{ marginBottom: 0, color: "#161F3D" }}
                                >
                                  Closed
                                </p>
                              </MainDiv>
                            )}
                          </div>
                          <div className="opening-hours-row">
                            <label
                              className="checkbox-row"
                              onClick={() => {
                                setWorkingDay("Su");
                              }}
                            >
                              <div
                                className={
                                  workingSu ? "workingDay" : "nonWorkingDay"
                                }
                              >
                                Su
                              </div>
                            </label>
                            {workingSu ? (
                              <div className="timer-row">
                                <div className="timer-one">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={SuOpen}
                                    onChange={(value) => {
                                      setSuOpen(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                                <div className="to-text">
                                  <p>—</p>
                                </div>
                                <div className="timer-two">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={SuClose}
                                    onChange={(value) => {
                                      setSuClose(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                              </div>
                            ) : (
                              <MainDiv>
                                <GreyClock
                                  style={{ marginLeft: 20, marginRight: 16 }}
                                />
                                <p
                                  style={{ marginBottom: 0, color: "#161F3D" }}
                                >
                                  Closed
                                </p>
                              </MainDiv>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="error-msg">
                      {opencloseTimeError === true ? (
                        <p className="error-message">
                          Closing Time should not be Greater than Opening Time
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <div style={{ width: "49%" }}>
                    <div className="form-group full-width">
                      <label>Email</label>
                      <Field
                        type="email"
                        name="email"
                        className="form-control"
                        disabled
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="error-message"
                      />
                    </div>
                    <div className="form-group full-width">
                      <label>Description</label>
                      <Field
                        type="text"
                        component="textarea"
                        name="description"
                        className="form-control"
                        rows="7"
                        // cols="50"
                      />
                      <ErrorMessage
                        name="description"
                        component="div"
                        className="error-message"
                      />
                      {errMsg && (
                        <div className="error-message">
                          Please enter a valid descritpion
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="submit gap-3">
                    <button type="submit" className="submit-btn">
                      Save Changes
                    </button>
                    <button
                      type="button"
                      className="submit-btn"
                      style={{
                        backgroundColor: "rgba(255,0,0, 0.9)",
                      }}
                      onClick={deleteAccountHandler}
                    >
                      Delete Account
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      ) : (
        <div className="edit-profile">
          <div className="edit-profile-box">
            <div className="title">
              <h2>Edit Club Profile</h2>
            </div>
            <Formik
              enableReinitialize={true}
              initialValues={{
                name: `${
                  data?.users?.length > 0 &&
                  data?.users[0] &&
                  data?.users[0]?.club_profile?.name
                    ? data?.users[0]?.club_profile?.name
                    : ""
                }`,
                email: `${
                  data?.users?.length > 0 &&
                  data.users[0] &&
                  data.users[0].email
                    ? data.users[0].email
                    : ""
                }`,
                phone: `${
                  data?.users?.length > 0 &&
                  data?.users[0] &&
                  data?.users[0]?.club_profile?.mobile_number
                    ? data?.users[0]?.club_profile?.mobile_number
                    : ""
                }`,
                website: `${
                  data?.users?.length > 0 &&
                  data?.users[0] &&
                  data?.users[0]?.club_profile?.website
                    ? data?.users[0]?.club_profile?.website
                    : ""
                }`,
                description: `${
                  data?.users?.length > 0 &&
                  data.users[0] &&
                  data.users[0].club_profile.description
                    ? data.users[0].club_profile.description
                    : ""
                }`,
                openingHours: [
                  {
                    dayName: "Monday",
                    button_status: false,
                    open: "",
                    close: "",
                    openDate: null,
                    closeDate: null,
                  },
                  {
                    dayName: "Tuesday",
                    button_status: false,
                    open: "",
                    close: "",
                    openDate: null,
                    closeDate: null,
                  },
                  {
                    dayName: "Wednesday",
                    button_status: false,
                    open: "",
                    close: "",
                    openDate: null,
                    closeDate: null,
                  },
                  {
                    dayName: "Thursday",
                    button_status: false,
                    open: "",
                    close: "",
                    openDate: null,
                    closeDate: null,
                  },
                  {
                    dayName: "Friday",
                    button_status: false,
                    open: "",
                    close: "",
                    openDate: null,
                    closeDate: null,
                  },
                  {
                    dayName: "Saturday",
                    button_status: false,
                    open: "",
                    close: "",
                    openDate: null,
                    closeDate: null,
                  },
                  {
                    dayName: "Sunday",
                    button_status: false,
                    open: "",
                    close: "",
                    openDate: null,
                    closeDate: null,
                  },
                ],
              }}
              validationSchema={Yup.object({
                name: Yup.string().required("Please anter the name"),
                email: Yup.string().email("Invalid Email Address"),
                website: Yup.string().matches(
                  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
                  "Please Enter Valid URL"
                ),
                description: Yup.string().required(
                  "Please enter the description"
                ),
                openingHours: Yup.array().of(
                  Yup.object({
                    open: Yup.string().when("button_status", {
                      is: (value) => value === true,
                      then: Yup.string().required(),
                      otherwise: Yup.string().nullable(),
                    }),
                    close: Yup.string()
                      .when("button_status", {
                        is: (value) => value === true,
                        then: Yup.string().required(),
                        otherwise: Yup.string().nullable(),
                      })
                      .test(
                        "is-greater",
                        "end time should be greater",
                        function (value) {
                          const { open } = this.parent;
                          return !open || !value
                            ? true
                            : moment(value, "h:mm aa").isSameOrAfter(
                                moment(open, "h:mm aa")
                              );
                        }
                      ),
                  })
                ),
              })}
              onSubmit={(values) => {
                // let flag = true;

                // for (let i = 0; i < days.length; i++) {
                //   if (
                //     days[i].open != null &&
                //     days[i].close != null
                //     // days[i].open >= days[i].close
                //   ) {
                //     flag = false;
                //     break;
                //   }
                // }

                // if (flag) {
                setopencloseTimeError(false);

                if (values.description) {
                  if (/^\s*$/.test(values.description)) {
                    //only spaces in the value
                    setErrMsg(true);
                  } else {
                    setErrMsg(false);
                    BuildClubProfile({
                      variables: {
                        data: {
                          email: values.email,
                          mobile_number: values.phone,
                          website: values.website,
                          description: values.description,
                          location_text: location_text,
                          location: {
                            type: "Point",
                            coordinates: cordinate,
                          },
                          name: values.name,
                          opening_hours: JSON.stringify(days),
                        },
                        userId: `${
                          data?.users?.length > 0 &&
                          data.users[0] &&
                          data.users[0].id
                            ? data.users[0].id
                            : ""
                        }`,
                      },
                    })
                      .then(() => {
                        history.push("/club-profile");
                      })
                      .catch((e) => {});
                  }
                }
                // } else {
                //   setopencloseTimeError(true);
                // }
              }}
            >
              {() => (
                <Form>
                  <div style={{ width: "49%" }}>
                    <div className="form-group full-width">
                      <label>Name</label>
                      <Field
                        type="name"
                        name="name"
                        className="form-control"
                        style={{ backgroundColor: "white" }}
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="error-message"
                      />
                    </div>
                    <div className="form-group full-width">
                      <label>Phone</label>
                      <Field type="tel" name="phone" className="form-control" />
                      <ErrorMessage
                        name="phone"
                        component="div"
                        className="error-message"
                      />
                    </div>
                    <div className="form-group full-width">
                      <label>Website</label>
                      <Field
                        type="text"
                        name="website"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="website"
                        component="div"
                        className="error-message"
                      />
                    </div>
                    <div className="form-group map-input full-width">
                      <label>Location</label>
                      {/* <Field type="text" name="address" className="form-control" />
              <ErrorMessage
                name="address"
                component="div"
                className="error-message"
              /> */}
                      <SearchAuto
                        setCordinate={setCordinate}
                        setLocation_text={setLocation_text}
                        location_text={location_text}
                      />
                    </div>
                    {/* <div className="form-group">
                <label>Opening Hours</label>
                <Field type="text" name="xyz" className="form-control" />
                <ErrorMessage name="xyz" component="div" className="error-message" />
              </div> */}
                    {/* <div className="form-group">
                <label>Opening Hours</label>
                {days.map((day,i)=>{
                  return (
                    <div className="d-flex opening-hours-main-div">
                  <div>
                  <ul style={{listStyle:"none"}}>
                        <li>
                          <div class="">
                            <input type="checkbox" id="checkbox" 
                              onClick={()=>{
                              selectDayHandler(day.dayName)
                              setFieldValue(
                                `openingHours.${i}.button_status`,
                                !values.openingHours[i].button_status
                              )
                              }
                              }/>
                            <label for="checkbox">{day.dayName}</label>
                          </div>
                        </li>
                    </ul>
                  </div>
                  {
                    day.button_status ? 
                    <div className="d-flex" >
                      <div>
                      <div>
                        <DatePicker
                          selected={
                            values.openingHours[i].openDate
                          }
                          dropdownMode="select"
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={60}
                          dateFormat="h:mm aa"
                          autoComplete="off"
                          id={`openingHours.${i}.open`}
                          name={`openingHours.${i}.open`}
                          onChange={(value) => {
                            setFieldValue(
                              `openingHours.${i}.open`,
                              moment(value).format("HH:mm")
                            )
                            setFieldValue(
                              `openingHours.${i}.openDate`,
                              value
                            );
                          }}
                          className="react-time-input"
                          calendarClassName="react-time-picker"
                          popperClassName="react-time-propper"
                        />
                      </div>
                      </div>
                      <div>To</div>
                      <div>
                      <div>
                        <DatePicker
                          selected={
                            values.openingHours[i].closeDate
                          }
                          dropdownMode="select"
                          showTimeSelect
                          showTimeSelectOnly
                          timeIntervals={60}
                          dateFormat="h:mm aa"
                          autoComplete="off"
                          id={`openingHours.${i}.close`}
                          name={`openingHours.${i}.close`}
                          onChange={(value) => {
                            setFieldValue(
                              `openingHours.${i}.close`,
                              moment(value).format("HH:mm")
                            )
                            setFieldValue(
                              `openingHours.${i}.closeDate`,
                              value
                            );
                          }}
                          className="react-time-input"
                          calendarClassName="react-time-picker"
                          popperClassName="react-time-propper"
                        />
                      </div>
                      </div>
                  </div>
                  : null
                  }
                </div>
                  )
                })}
              </div> */}

                    <div className="time-block full-width">
                      <div className="main-title">
                        <h3>Set Opening Hours</h3>
                      </div>
                      <div className="opening-hours-cover">
                        <div className="col-left">
                          <div className="opening-hours-row">
                            <label
                              className="checkbox-row"
                              onClick={() => {
                                setWorkingDay("Mo");
                              }}
                            >
                              <div
                                className={
                                  workingMo ? "workingDay" : "nonWorkingDay"
                                }
                              >
                                Mo
                              </div>
                            </label>
                            {workingMo ? (
                              <div className="timer-row">
                                <div className="timer-one">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={MoOpen}
                                    onChange={(value) => {
                                      setMonOpen(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                                <div className="to-text">
                                  <p>—</p>
                                </div>
                                <div className="timer-two">
                                  <DatePicker
                                    selected={MoClose}
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    onChange={(value) => {
                                      setMonClose(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                              </div>
                            ) : (
                              <MainDiv>
                                <GreyClock
                                  style={{ marginLeft: 20, marginRight: 16 }}
                                />
                                <p
                                  style={{ marginBottom: 0, color: "#161F3D" }}
                                >
                                  Closed
                                </p>
                              </MainDiv>
                            )}
                          </div>
                          <div className="opening-hours-row">
                            <label
                              className="checkbox-row"
                              onClick={() => {
                                setWorkingDay("Tu");
                              }}
                            >
                              <div
                                className={
                                  workingTu ? "workingDay" : "nonWorkingDay"
                                }
                              >
                                Tu
                              </div>
                            </label>
                            {workingTu ? (
                              <div className="timer-row">
                                <div className="timer-one">
                                  <DatePicker
                                    selected={TuOpen}
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    onChange={(value) => {
                                      setTuOpen(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                                <div className="to-text">
                                  <p>—</p>
                                </div>
                                <div className="timer-two">
                                  <DatePicker
                                    selected={TuClose}
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    onChange={(value) => {
                                      setTuClose(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                              </div>
                            ) : (
                              <MainDiv>
                                <GreyClock
                                  style={{ marginLeft: 20, marginRight: 16 }}
                                />
                                <p
                                  style={{ marginBottom: 0, color: "#161F3D" }}
                                >
                                  Closed
                                </p>
                              </MainDiv>
                            )}
                          </div>
                          <div className="opening-hours-row">
                            <label
                              className="checkbox-row"
                              onClick={() => {
                                setWorkingDay("We");
                              }}
                            >
                              <div
                                className={
                                  workingWe ? "workingDay" : "nonWorkingDay"
                                }
                              >
                                We
                              </div>
                            </label>
                            {workingWe ? (
                              <div className="timer-row">
                                <div className="timer-one">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={WeOpen}
                                    onChange={(value) => {
                                      setWeOpen(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                                <div className="to-text">
                                  <p>—</p>
                                </div>
                                <div className="timer-two">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={WeClose}
                                    onChange={(value) => {
                                      setWeClose(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                              </div>
                            ) : (
                              <MainDiv>
                                <GreyClock
                                  style={{ marginLeft: 20, marginRight: 16 }}
                                />
                                <p
                                  style={{ marginBottom: 0, color: "#161F3D" }}
                                >
                                  Closed
                                </p>
                              </MainDiv>
                            )}
                          </div>
                          <div className="opening-hours-row">
                            <label
                              className="checkbox-row"
                              onClick={() => {
                                setWorkingDay("Th");
                              }}
                            >
                              <div
                                className={
                                  workingTh ? "workingDay" : "nonWorkingDay"
                                }
                              >
                                Th
                              </div>
                            </label>
                            {workingTh ? (
                              <div className="timer-row">
                                <div className="timer-one">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={ThOpen}
                                    onChange={(value) => {
                                      setThOpen(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                                <div className="to-text">
                                  <p>—</p>
                                </div>
                                <div className="timer-two">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={ThClose}
                                    onChange={(value) => {
                                      setThClose(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                              </div>
                            ) : (
                              <MainDiv>
                                <GreyClock
                                  style={{ marginLeft: 20, marginRight: 16 }}
                                />
                                <p
                                  style={{ marginBottom: 0, color: "#161F3D" }}
                                >
                                  Closed
                                </p>
                              </MainDiv>
                            )}
                          </div>
                          <div className="opening-hours-row">
                            <label
                              className="checkbox-row"
                              onClick={() => {
                                setWorkingDay("Fr");
                              }}
                            >
                              <div
                                className={
                                  workingFr ? "workingDay" : "nonWorkingDay"
                                }
                              >
                                Fr
                              </div>
                            </label>
                            {workingFr ? (
                              <div className="timer-row">
                                <div className="timer-one">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={FrOpen}
                                    onChange={(value) => {
                                      setFrOpen(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                                <div className="to-text">
                                  <p>—</p>
                                </div>
                                <div className="timer-two">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={FrClose}
                                    onChange={(value) => {
                                      setFrClose(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                              </div>
                            ) : (
                              <MainDiv>
                                <GreyClock
                                  style={{ marginLeft: 20, marginRight: 16 }}
                                />
                                <p
                                  style={{ marginBottom: 0, color: "#161F3D" }}
                                >
                                  Closed
                                </p>
                              </MainDiv>
                            )}
                          </div>
                          <div className="opening-hours-row">
                            <label
                              className="checkbox-row"
                              onClick={() => {
                                setWorkingDay("Sa");
                              }}
                            >
                              <div
                                className={
                                  workingSa ? "workingDay" : "nonWorkingDay"
                                }
                              >
                                Sa
                              </div>
                            </label>
                            {workingSa ? (
                              <div className="timer-row">
                                <div className="timer-one">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={SaOpen}
                                    onChange={(value) => {
                                      setSaOpen(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                                <div className="to-text">
                                  <p>—</p>
                                </div>
                                <div className="timer-two">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={SaClose}
                                    onChange={(value) => {
                                      setSaClose(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                              </div>
                            ) : (
                              <MainDiv>
                                <GreyClock
                                  style={{ marginLeft: 20, marginRight: 16 }}
                                />
                                <p
                                  style={{ marginBottom: 0, color: "#161F3D" }}
                                >
                                  Closed
                                </p>
                              </MainDiv>
                            )}
                          </div>
                          <div className="opening-hours-row">
                            <label
                              className="checkbox-row"
                              onClick={() => {
                                setWorkingDay("Su");
                              }}
                            >
                              <div
                                className={
                                  workingSu ? "workingDay" : "nonWorkingDay"
                                }
                              >
                                Su
                              </div>
                            </label>
                            {workingSu ? (
                              <div className="timer-row">
                                <div className="timer-one">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={SuOpen}
                                    onChange={(value) => {
                                      setSuOpen(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                                <div className="to-text">
                                  <p>—</p>
                                </div>
                                <div className="timer-two">
                                  <DatePicker
                                    dropdownMode="select"
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    dateFormat="h:mm aa"
                                    autoComplete="off"
                                    selected={SuClose}
                                    onChange={(value) => {
                                      setSuClose(value);
                                    }}
                                    className="react-time-input"
                                    calendarClassName="react-time-picker"
                                    popperClassName="react-time-propper"
                                  />
                                </div>
                              </div>
                            ) : (
                              <MainDiv>
                                <GreyClock
                                  style={{ marginLeft: 20, marginRight: 16 }}
                                />
                                <p
                                  style={{ marginBottom: 0, color: "#161F3D" }}
                                >
                                  Closed
                                </p>
                              </MainDiv>
                            )}
                          </div>
                        </div>

                        {/* <div className="col-right">
                      <div className="timer-row">
                        <div className="timer-one">
                            Timer 1
                        </div>
                        <div className="to-text">
                          <p>to</p>
                        </div>
                        <div className="timer-two">
                            Timer 2
                        </div>
                      </div>                                           
                  </div>               */}
                      </div>
                    </div>
                    <div className="error-msg">
                      {opencloseTimeError === true ? (
                        <p className="error-message">
                          Closing Time should not be Greater than Opening Time
                        </p>
                      ) : null}
                    </div>
                  </div>
                  <div style={{ width: "49%" }}>
                    <div className="form-group full-width">
                      <label>Email</label>
                      <Field
                        type="email"
                        name="email"
                        className="form-control"
                        disabled
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="error-message"
                      />
                    </div>
                    <div className="form-group full-width">
                      <label>Description</label>
                      <Field
                        type="text"
                        component="textarea"
                        name="description"
                        className="form-control"
                        rows="7"
                        // cols="50"
                      />
                      <ErrorMessage
                        name="description"
                        component="div"
                        className="error-message"
                      />
                      {errMsg && (
                        <div className="error-message">
                          Please enter a valid descritpion
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="submit gap-3">
                    <button type="submit" className="submit-btn">
                      Save Changes
                    </button>
                    <button
                      type="button"
                      className="submit-btn"
                      style={{
                        backgroundColor: "rgba(255,0,0, 0.9)",
                      }}
                      onClick={deleteAccountHandler}
                    >
                      Delete Account
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      )}
    </>
  );
};

export default EditBusinessProfile;
